import type { PropsWithChildren } from 'react'
import { Button } from '@/components/ui/button'
import { SectionShell } from '@/components/layout/SectionShell'

export function ContactSection({ children }: PropsWithChildren) {
  return (
    <SectionShell
      id="contact"
      labelledBy="contact-heading"
      className="page-snap-section flex flex-col border-t border-border pt-16 text-center sm:pt-20"
    >
      <div className="reveal mx-auto flex flex-1 max-w-5xl flex-col items-center justify-center space-y-10">
        <div className="space-y-6">
          <h2
            id="contact-heading"
            className="font-display text-4xl font-semibold tracking-[-0.04em] text-foreground sm:text-5xl md:text-[56px]"
          >
            Ready to <span className="text-primary">build</span>?
          </h2>
          <p className="mx-auto max-w-xl text-md leading-8 text-muted">
            Get in touch to explore how we build AI and software solutions for real world use cases. Let's <span className="font-semibold">compute</span> together.
          </p>
        </div>
        <div className="flex flex-col items-center justify-center gap-6 sm:flex-row">
          <Button asChild className="rounded-md" size="lg">
            <a href="https://theprojectone.co">
               Project One
            </a>
          </Button>
        </div>
      </div>
      {children}
    </SectionShell>
  )
}
